var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88902 17.5274C4.05151 17.5274 1.7036 15.3649 1.37325 12.584H18.6277C18.2973 15.3649 15.9494 17.5274 13.111 17.5274H6.88902ZM8.00018 6.51698C8.00018 5.40168 8.89748 4.49434 10.0005 4.49434C11.1034 4.49434 11.9998 5.40168 11.9998 6.51698C11.9998 6.64121 11.9006 6.74151 11.7778 6.74151H8.22223C8.10029 6.74151 8.00018 6.64121 8.00018 6.51698ZM6.88902 0C3.0905 0 0 3.12506 0 6.96604V11.9104C0 14.8808 1.84921 17.4234 4.44465 18.4227V20H5.77786V18.7844C6.14006 18.8451 6.51044 18.8764 6.88902 18.8764H13.111C13.4896 18.8764 13.8609 18.8451 14.2231 18.7844V20H15.5554V18.4227C18.1517 17.4234 20 14.8808 20 11.9104V11.2359H1.33321V6.96604C1.33321 3.86859 3.82582 1.34812 6.88902 1.34812C8.03567 1.34812 9.00032 2.15147 9.26241 3.23088C7.77813 3.57044 6.66697 4.91488 6.66697 6.51698C6.66697 7.38474 7.36497 8.08963 8.22223 8.08963H11.7778C12.6359 8.08963 13.3339 7.38474 13.3339 6.51698C13.3339 4.87163 12.1618 3.49867 10.6175 3.20512C10.3253 1.39045 8.76462 0 6.88902 0Z",
    fill: "#69757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.7e9217c3321cb562864cafb1ce0c49fd.svg";
export { ForwardRef as ReactComponent };